import * as types from '../types'

export const setUser = (user) => {
    return (dispatch) => {
        dispatch({ type: types.SET_USER, payload: user })
    }
}

const userActions = {
    login: (user = {}) => {
        return (dispatch) => {
            dispatch({ type: types.LOGIN, payload: user })
        }
    },
    logout: () => {
        return (dispatch) => {
            localStorage.removeItem('user')
            dispatch({ type: types.LOGOUT })
            window.location.reload()
        }
    },
    tokenRefreshOn: () => {
        return (dispatch) => {
            dispatch({ type: types.REFRESHON })
        }
    },
    tokenRefreshOff: () => {
        return (dispatch) => {
            dispatch({ type: types.REFRESHOFF })
        }
    },
    updateTokens: (payload) => {
        return (dispatch) => {
            dispatch({ type: types.REFRESHTOKEN, payload })
        }
    },
}

export default userActions
